// @flow

import _ from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Navbar from 'client/components/Navbar';
import Loading from 'client/components/Loading';
import { logout } from 'client/containers/Login/redux';
import { getToken } from 'client/utils/user';
import history from 'client/utils/history';
import Styles from './styles';
import { getProfile, getAbout } from './redux';

type Props = {
  profileData : any,
  getProfileLoading : boolean,
  getProfile : () => void,
  getAbout : () => void,
  logout : () => void,
  logoutLoading : boolean,
  aboutData : any,
  getAboutLoading : boolean,
};

const Profile = ({
  getProfile,
  getAbout,
  logout: logoutAction,
  getProfileLoading,
  profileData,
  logoutLoading,
  aboutData,
  getAboutLoading,
} : Props) => {
  useEffect(() => {
    if (getToken()) {
      if (profileData.size === 0) {
        getProfile();
      }
      if (!aboutData) {
        getAbout();
      }
    } else {
      history.push('/');
    }
  }, [profileData, aboutData]);

  return (
    <Styles className="rtl">
      {!logoutLoading && <Navbar />}
      {
        (logoutLoading || (getProfileLoading && profileData.size === 0) ||
        (getAboutLoading && !aboutData))
          ? <Loading />
          : (profileData.size > 0) &&
          <div className="profileDetailsWrapper">
            <div className="profileDetails">
              <h1>پروفایل</h1>
              <div>
                {
                  profileData.getIn(['mobile_valid']) &&
                  <p>
                    شماره موبایل:
                    <span>{profileData.getIn(['mobile_valid'])}</span>
                  </p>
                }
                {
                  profileData.getIn(['email']) &&
                  <p>
                    آدرس ایمیل:
                    <span>{profileData.getIn(['email'])}</span>
                  </p>
                }
              </div>
            </div>
            <div className="section selectableRow logoutContainer">
              <div className="textWrapper logout">
                <h3 className="sectionTitle">خروج از حساب کاربری</h3>
              </div>
              <button
                className="actionButton selectableItem"
                clickable="true"
                onClick={logoutAction}
                style={{ visibility: (getProfileLoading || logoutLoading) ? 'hidden' : 'visible' }}
              >
                خروج
              </button>
              {aboutData && (
                <div className="about_phrase">
                  {aboutData.getIn(['phrase'])}
                </div>
              )}
            </div>
          </div>
      }
      {/* eslint-disable-next-line */}
      <span className="version">نسخه: {_.get(process.env.APP_CONFIG, ['APP_GLOBAL_CONFIG', 'APP_VERSION'], '')}</span>
    </Styles>
  );
};

export default connect(
  (state : any) => ({
    getProfileLoading: state.getIn(['Profile', 'getProfileLoading']),
    profileData: state.getIn(['Profile', 'profileData']),
    aboutData: state.getIn(['Profile', 'aboutData']),
    getAboutLoading: state.getIn(['Profile', 'getAboutLoading']),
    authenticationData: state.getIn(['Login', 'authenticationData']),
    logoutLoading: state.getIn(['Login', 'logoutLoading']),
  }),
  {
    getProfile,
    logout,
    getAbout,
  },
)(Profile);
